import PageTitleComponent from "../../components/PageTitle";
import UpdateUserPassword from "../../components/Profile/UpdateUserPassword";

export default function UserPasswordUpdateScreen(){
return <div>
    <PageTitleComponent title="Password User Update" />
    <UpdateUserPassword/>
</div>
}